import { ApiResponse, DataObject } from "@/types";
import { SnkResponse } from "./interface";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { useFormMutation } from "@/hooks/useFormMutation";
import { SnkPayload } from "./validation";

const getSnk = async (): Promise<ApiResponse<DataObject<SnkResponse>>> => {
  return await fetcher(`master/terms-conditions/1`);
};

export const useGetSnk = () => {
  return useQuery<ApiResponse<DataObject<SnkResponse>>, Error>({
    queryKey: ["useGetSnk"],
    queryFn: () => getSnk(),
  });
};

// Mutation
export const useSnk = () => {
  return useFormMutation<
    ApiResponse<DataObject<SnkResponse>>,
    Error,
    SnkPayload
  >({
    mutationFn: async (data): Promise<ApiResponse<DataObject<SnkResponse>>> => {
      const endpoint = `master/terms-conditions/1`;
      const response: ApiResponse<DataObject<SnkResponse>> = await sendData(
        endpoint,
        data,
        "PUT"
      );
      return response;
    },
    loadingMessage: "Memperbarui data...",
    successMessage: "Data berhasil diperbarui",
  });
};
